const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
const HISTORY_KEY = 'vfMobileOverlay';

const overlays = [
  { selector: '.vfca-dialog[open]', close: element => element.querySelector('.vfca-close')?.click() },
  {
    selector: '.vf-cart[open]',
    close: (element) => element.querySelector('[data-vf-cart-close]')?.click(),
  },
  {
    selector: '.search-modal__content[open]',
    close: (element) => element.querySelector('.predictive-search__close-modal-button')?.click(),
  },
  {
    selector: '.dialog-zoomed-gallery__dialog[open]',
    close: (element) => element.querySelector('.dialog-zoomed-gallery__close-button')?.click(),
  },
  {
    selector: '#Details-menu-drawer-container[open]',
    close: (element) => element.querySelector('.menu-drawer__close-button')?.click(),
  },
];

let activeOverlay = null;
let restoringHistory = false;

function findOpenOverlay() {
  for (const overlay of overlays) {
    const element = document.querySelector(overlay.selector);
    if (element) return { ...overlay, element };
  }
  return null;
}

function syncOverlayHistory() {
  if (!MOBILE_QUERY.matches || restoringHistory) return;

  const openOverlay = findOpenOverlay();
  if (openOverlay && activeOverlay) {
    activeOverlay = openOverlay;
    return;
  }
  if (openOverlay && !activeOverlay) {
    activeOverlay = openOverlay;
    if (!history.state?.[HISTORY_KEY]) {
      history.pushState({ ...history.state, [HISTORY_KEY]: true }, '', window.location.href);
    }
    return;
  }

  if (!openOverlay && activeOverlay) {
    activeOverlay = null;
    if (history.state?.[HISTORY_KEY]) history.back();
  }
}

window.addEventListener('popstate', () => {
  if (!activeOverlay) return;

  const overlay = activeOverlay;
  activeOverlay = null;
  restoringHistory = true;
  overlay.close(overlay.element);
  requestAnimationFrame(() => {
    restoringHistory = false;
  });
});

new MutationObserver(syncOverlayHistory).observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['open'],
  childList: true,
  subtree: true,
});
